import { webCoreTypes } from "@core/core-types.di";
import { FallbackError } from "@core/domain/errors/fallback.error";
import type { IotApiClient } from "@iot-platform/core";
import type { RouteDto } from "@station/data/dto/route.dto";
import { RouteMapper } from "@station/data/mappers/route.mapper";
import type { Route, RouteFilter } from "@station/domain/models/route.model";
import { inject, injectable } from "inversify";
import type { ResultAsync } from "neverthrow";

@injectable()
export class RouteDatasource {
    static readonly ROUTE_PATH = "/route_gps";

    constructor(
        @inject(webCoreTypes.infrastructure.IotApiClient)
        private readonly iotApiClient: IotApiClient,
        @inject(RouteMapper)
        private readonly routeMapper: RouteMapper,
    ) {}

    fetchAllRoute(routeFilter: RouteFilter): ResultAsync<Route, FallbackError> {
        const query = {
            station_ids: routeFilter.stationId,
            from: routeFilter.from,
            to: routeFilter.to,
        };

        return this.iotApiClient.http
            .get<RouteDto>(RouteDatasource.ROUTE_PATH, {
                query,
            })
            .mapErr(() => new FallbackError())
            .andThen((response) =>
                this.routeMapper
                    .map(response.data)
                    .mapErr(() => new FallbackError()),
            );
    }
}
